import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class LinkToProduct extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get description() {
    return get(this, '_description.value', '');
  }

  get slug() {
    return get(this, '_product_slugs.taxonomyTerms[0].name', '/');
  }

  get url() {
    return get(this, '_url.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/LinkToProduct.model.js